import React from 'react';
import QRCode from 'qrcode.react';
import { getToken, onMessageListener } from '../../firebase';

export default class App extends React.Component {

  state = {}

  render() {
    return (
      <div>
        <div style={{textAlign: 'right', color: 'red', cursor: 'pointer', marginBottom: '2%'}} 
            onClick={this.props.close}>Close</div>
        <QRCode size={this.props.size} level={this.props.level} value={this.props.value} />
      </div>
    );
  }
}